<div class="litmus-link-container">
    <a href="#" [href]="link.value" target="_blank" *ngFor="let link of links;"><img src="assets/images/open_in_new.png"/> {{link.value}}</a>
</div>